// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);

  const cartNote = document.getElementById('CartSpecialInstructions');
  
  if(cartNote){
    cartNote.addEventListener("input", function() {
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ note: cartNote.value })
      })
      .then(response => response.json())
      .then(data => console.log(data));
    });
  }
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});

(function () {
  // Shopify's error redirect for the restock form drops ?variant=, but keeps contact[Variant] ("Title (id)").
  const params = new URLSearchParams(window.location.search);
  if (params.get("form_type") !== "contact" || params.has("variant")) return;

  const match = /\((\d+)\)\s*$/.exec(params.get("contact[Variant]") || "");
  if (!match) return;

  params.set("variant", match[1]);
  window.location.replace(window.location.pathname + "?" + params.toString() + window.location.hash);
})();

// Restock notify form: the theme doesn't re-render Liquid on variant change,
// so toggle the buy buttons / restock form / quantity selector here.
(function () {
  const productSelector = '[data-section-type="product"], [data-section-type="featured-product"]';
  let activeProduct = null;

  // Capture phase runs before the theme's option listeners, which dispatch
  // "product:variant-change" synchronously without identifying the product container.
  document.addEventListener("change", function (evt) {
    activeProduct = evt.target instanceof Element ? evt.target.closest(productSelector) : null;
  }, true);

  document.addEventListener("product:variant-change", function (evt) {
    if (!activeProduct) return;

    const variant = evt.detail && evt.detail.variant;
    const isAvailable = Boolean(variant && variant.available);
    const isSoldOut = Boolean(variant) && !isAvailable;
    const notifyWrappers = activeProduct.querySelectorAll("[data-restock-notify]");

    if (notifyWrappers.length) {
      notifyWrappers.forEach(function (el) { el.hidden = !isSoldOut; });
      activeProduct.querySelectorAll("[data-restock-buy-buttons]").forEach(function (el) { el.hidden = isSoldOut; });
    }

    activeProduct.querySelectorAll("[data-hide-when-unavailable]").forEach(function (el) { el.hidden = !isAvailable; });

    if (variant) {
      activeProduct.querySelectorAll("[data-restock-variant-input]").forEach(function (input) {
        input.value = variant.title + " (" + variant.id + ")";
      });
    }
  });

  document.addEventListener("submit", function (evt) {
    const returnTo = evt.target instanceof Element ? evt.target.querySelector("[data-restock-return-to]") : null;
    if (!returnTo) return;

    // The theme keeps ?variant= in the URL in sync; strip stale contact params from earlier submits.
    const params = new URLSearchParams(window.location.search);
    Array.from(params.keys()).forEach(function (key) {
      if (key !== "variant") params.delete(key);
    });
    // return_to replaces Shopify's default success redirect, which is what adds contact_posted=true.
    params.set("contact_posted", "true");
    returnTo.value = window.location.pathname + "?" + params.toString() + "#notify_me";
  });
})();
